import {
  limitedReleaseByVirtualConstants,
  createLimitedReleaseByVirtualConstants,
  editLimitedReleaseByVirtualConstants,
  activateLimitedReleaseByVirtualConstants,
  deactivateLimitedReleaseByVirtualConstants,
  deleteLimitedReleaseByVirtualConstants,
} from "../_redux-constants";

export function limitedReleasesVirtualReducer(
  state = {
    limitedReleaseByVirtualLoading: false,
    limitedReleaseByVirtualData: null,
    limitedReleaseByVirtualError: null,

    createLimitedReleaseByVirtualLoading: false,
    createLimitedReleaseByVirtualData: null,
    createLimitedReleaseByVirtualError: null,

    editLimitedReleaseByVirtualLoading: false,
    editLimitedReleaseByVirtualData: null,
    editLimitedReleaseByVirtualError: null,

    activateLimitedReleaseByVirtualLoading: false,
    activateLimitedReleaseByVirtualData: null,
    activateLimitedReleaseByVirtualError: null,

    deactivateLimitedReleaseByVirtualLoading: false,
    deactivateLimitedReleaseByVirtualData: null,
    deactivateLimitedReleaseByVirtualError: null,

    deleteLimitedReleaseByVirtualLoading: false,
    deleteLimitedReleaseByVirtualData: null,
    deleteLimitedReleaseByVirtualError: null,
  },
  action
) {
  switch (action.type) {
    case limitedReleaseByVirtualConstants.LIMITED_RELEASE_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        limitedReleaseByVirtualLoading: true,
        limitedReleaseByVirtualData: null,
        limitedReleaseByVirtualError: null,
      });
    case limitedReleaseByVirtualConstants.LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        limitedReleaseByVirtualLoading: false,
        limitedReleaseByVirtualData: action.data,
      });
    case limitedReleaseByVirtualConstants.LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        limitedReleaseByVirtualLoading: false,
        limitedReleaseByVirtualData: null,
        limitedReleaseByVirtualError: action.error,
      });
    case createLimitedReleaseByVirtualConstants.CREATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        createLimitedReleaseByVirtualLoading: true,
        createLimitedReleaseByVirtualData: null,
        createLimitedReleaseByVirtualError: null,
      });
    case createLimitedReleaseByVirtualConstants.CREATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        createLimitedReleaseByVirtualLoading: false,
        createLimitedReleaseByVirtualData: action.data,
      });
    case createLimitedReleaseByVirtualConstants.CREATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        createLimitedReleaseByVirtualLoading: false,
        createLimitedReleaseByVirtualData: null,
        createLimitedReleaseByVirtualError: action.error,
      });
    case editLimitedReleaseByVirtualConstants.EDIT_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        editLimitedReleaseByVirtualLoading: true,
        editLimitedReleaseByVirtualData: null,
        editLimitedReleaseByVirtualError: null,
      });
    case editLimitedReleaseByVirtualConstants.EDIT_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        editLimitedReleaseByVirtualLoading: false,
        editLimitedReleaseByVirtualData: action.data,
      });
    case editLimitedReleaseByVirtualConstants.EDIT_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        editLimitedReleaseByVirtualLoading: false,
        editLimitedReleaseByVirtualData: null,
        editLimitedReleaseByVirtualError: action.error,
      });
    case activateLimitedReleaseByVirtualConstants.ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        activateLimitedReleaseByVirtualLoading: true,
        activateLimitedReleaseByVirtualData: null,
        activateLimitedReleaseByVirtualError: null,
      });
    case activateLimitedReleaseByVirtualConstants.ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        activateLimitedReleaseByVirtualLoading: false,
        activateLimitedReleaseByVirtualData: action.data,
      });
    case activateLimitedReleaseByVirtualConstants.ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        activateLimitedReleaseByVirtualLoading: false,
        activateLimitedReleaseByVirtualData: null,
        activateLimitedReleaseByVirtualError: action.error,
      });
    case deactivateLimitedReleaseByVirtualConstants.DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByVirtualLoading: true,
        deactivateLimitedReleaseByVirtualData: null,
        deactivateLimitedReleaseByVirtualError: null,
      });
    case deactivateLimitedReleaseByVirtualConstants.DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByVirtualLoading: false,
        deactivateLimitedReleaseByVirtualData: action.data,
      });
    case deactivateLimitedReleaseByVirtualConstants.DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByVirtualLoading: false,
        deactivateLimitedReleaseByVirtualData: null,
        deactivateLimitedReleaseByVirtualError: action.error,
      });
    case deleteLimitedReleaseByVirtualConstants.DELETE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        deleteLimitedReleaseByVirtualLoading: true,
        deleteLimitedReleaseByVirtualData: null,
        deleteLimitedReleaseByVirtualError: null,
      });
    case deleteLimitedReleaseByVirtualConstants.DELETE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        deleteLimitedReleaseByVirtualLoading: false,
        deleteLimitedReleaseByVirtualData: action.data,
      });
    case deleteLimitedReleaseByVirtualConstants.DELETE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        deleteLimitedReleaseByVirtualLoading: false,
        deleteLimitedReleaseByVirtualData: null,
        deleteLimitedReleaseByVirtualError: action.error,
      });
    default:
      return state;
  }
}
